import Vue from "vue";
import VueRouter from "vue-router";
import Quotes from "../views/Quotes.vue";
import QuotesInfo from "../views/QuotesInfo.vue";
import Login from "../views/Login.vue";
import Template from "../views/Template.vue";
import DeliveryNotes from "../views/DeliveryNotes.vue";
import DeliveryNotesInfo from "../views/DeliveryNotesInfo.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Quotes",
    component: Quotes
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/deliveryNotes",
    name: "DeliveryNotes",
    component: DeliveryNotes
  },
  {
    path: "/DeliveryNotesInfo/:id",
    name: "DeliveryNotesInfo",
    component: DeliveryNotesInfo
  },
  {
    path: "/quotesinfo/:id",
    name: "QuotesInfo",
    component: QuotesInfo
  },
  {
    path: "/template/:id",
    name: "Template",
    component: Template
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
